/******************************************************************************************
 *	Person Form Directive
 *******************************************************************************************
 *
 * Changes element order in DOM to obtain locale-specific formats.
 *
 */
(function() {
  

  angular.module('rcDirectives.personForm', []).directive(
    'rcPersonForm',
    /* @ngInject */
    function($rootScope, locale) {
      return {
        restrict: 'A',
        link: function(scope, element) {
          //Tracks if the format was changed in order to know when to revert
          var formatChanged = false;

          //DOM elements
          var firstNameColumn = element[0].querySelector('.js-person-first-name');
          var lastNameColumn = element[0].querySelector('.js-person-last-name');

          if (firstNameColumn && lastNameColumn) {
            //Family name comes before the given name.
            if (locale.isSurnameFirstNameLocale()) {
              formatChanged = true;

              //Swap First and Last names
              element[0].insertBefore(lastNameColumn, firstNameColumn);
            } else if (formatChanged) {
              formatChanged = false;

              //Swap First and Last names
              element[0].insertBefore(firstNameColumn, lastNameColumn);
            }
          }
        }
      };
    }
  );
})();
